var _style, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Stroke",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#252525;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "StrokeTwo",
    className: "st0",
    x1: 10.5,
    y1: 5,
    x2: 10.5,
    y2: 27
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "StrokeOne_00000012468672161970952480000002229146854942018451_",
    className: "st0",
    x1: 21.5,
    y1: 5,
    x2: 21.5,
    y2: 27
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseBlackIcon);
export default __webpack_public_path__ + "static/media/PauseBlackIcon.890584d20633eff909a13eab135a1f11.svg";
export { ForwardRef as ReactComponent };